import script from "./Disclaimers.vue?vue&type=script&setup=true&lang=js"
export * from "./Disclaimers.vue?vue&type=script&setup=true&lang=js"

import "./Disclaimers.vue?vue&type=style&index=0&id=739a28d5&scoped=true&lang=scss"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739a28d5"]])

export default __exports__